import svgSprite from '@assets/sprites/sprite.svg';

const setSvgSprite = () => {
  if (svgSprite) {
    document.getElementById('svg-sprite-container').innerHTML = svgSprite;
  }
};

export default setSvgSprite;
